import { createContext } from 'react';

var FormContext = /*#__PURE__*/createContext({});

export { FormContext as default };
